(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[423],{

/***/ 3743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ service; }
});

// EXTERNAL MODULE: ./components/_OldDesign/header.tsx + 1 modules
var header = __webpack_require__(6627);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./styles/Content.module.scss
var Content_module = __webpack_require__(8369);
var Content_module_default = /*#__PURE__*/__webpack_require__.n(Content_module);
// EXTERNAL MODULE: ./styles/culture.module.scss
var culture_module = __webpack_require__(1559);
var culture_module_default = /*#__PURE__*/__webpack_require__.n(culture_module);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/lib/styles.css
var styles = __webpack_require__(6494);
// EXTERNAL MODULE: ./models/conent.ts
var conent = __webpack_require__(3290);
// EXTERNAL MODULE: ./utils/translate.ts
var translate = __webpack_require__(954);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/_OldDesign/productHeader.tsx
var productHeader = __webpack_require__(2111);
// EXTERNAL MODULE: ./components/_OldDesign/content.tsx + 1 modules
var content = __webpack_require__(3714);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./utils/validation.ts
var validation = __webpack_require__(1672);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/_OldDesign/input.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Input = function Input(_ref) {
  var contents = _ref.contents,
      register = _ref.register,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  var _useState = (0,react.useState)( /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})),
      content = _useState[0],
      setContent = _useState[1];

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  (0,react.useEffect)(function () {
    switch (contents === null || contents === void 0 ? void 0 : contents.inputType) {
      case 'button':
        setContent( /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex justify-center py-6 md:py-3",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              style: {
                marginTop: '20px'
              },
              type: "submit",
              className: "btn custom-blue-button disabled:bg-neutral-300",
              disabled: disabled,
              children: (0,translate/* translate */.Iu)(contents, 'label', lang)
            })
          })
        }));
        break;

      case 'checkbox':
        setContent( /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "my-6 md:my-5 text-left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
            type: "checkbox",
            className: "mt-4 form-radio xl:h-4 xl:w-4",
            name: contents.name
          }, register(contents.name == 'eBudget' ? 'eBudget' : contents.name == 'eClaim' ? 'eClaim' : contents.name == 'eService' ? 'eService' : contents.name == 'fixAsset' ? 'fixAsset' : contents.name == 'eBilling' ? 'eBilling' : 'none', _objectSpread({}, (0,validation/* requiredRule */.n0)(contents.required, (0,translate/* translate */.Iu)(contents, 'label', lang), lang))))), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: "text-3xl md:text-xl ml-6 xl:text-xs",
            children: (0,translate/* translate */.Iu)(contents, 'label', lang)
          })]
        }));
        break;

      case 'textarea':
        setContent( /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "my-10 md:my-8",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: "text-4xl md:text-xl xl:text-xs",
            children: [(0,translate/* translate */.Iu)(contents, 'label', lang), contents.required ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-red float-right",
              children: "*"
            }) : '']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", _objectSpread({
            placeholder: (0,translate/* translate */.Iu)(contents, 'placeHolder', lang),
            name: contents.name,
            className: "mt-2 w-full text-grey-darkest shadow-sm h-36 text-3xl md:text-xl xl:text-xs p-4"
          }, register(contents.name == 'detail' ? 'detail' : 'none', _objectSpread({}, (0,validation/* requiredRule */.n0)(contents.required, contents.placeHolder, lang, {
            possessive: false,
            lowercase: false
          })))))]
        }));
        break;

      case 'text':
        setContent( /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "my-10 md:my-8 relative text-left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: "text-4xl md:text-xl xl:text-xs",
            children: [(0,translate/* translate */.Iu)(contents, 'label', lang), contents.required ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-red",
              children: "*"
            }) : '']
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
            className: "mt-2 rounded-md bg-white border-none lg:shadow-sm border-gray-300 py-2 px-3 text-grey-darkest h-20 lg:h-12 w-full text-3xl md:text-xl xl:text-xs",
            name: contents.name,
            type: "text",
            placeholder: (0,translate/* translate */.Iu)(contents, 'placeHolder', lang)
          }, register(contents.name == 'name' ? 'name' : contents.name == 'company_name' ? 'company_name' : contents.name == 'job' ? 'job' : contents.name == 'email' ? 'email' : contents.name == 'phoneNumber' ? 'phoneNumber' : 'none', _objectSpread(_objectSpread({}, (0,validation/* requiredRule */.n0)(contents.required, (0,translate/* translate */.Iu)(contents, 'label', lang), lang)), (0,validation/* formatRules */.jU)(contents.name, lang)))))]
        }));
        break;

      default:
    }
  }, [lang, disabled]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "px-12",
    children: content
  });
};

/* harmony default export */ var input = (Input);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./utils/gtm.ts
var gtm = __webpack_require__(5834);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/_OldDesign/successRegistration.tsx







var SuccessRegistration = function SuccessRegistration(_ref) {
  var showModal = _ref.showModal,
      setShowModal = _ref.setShowModal;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: showModal ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative w-auto my-6 mx-auto max-w-3xl",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "bg-modal-success border-0 rounded-lg shadow-lg relative flex flex-col h-auto xl:h-1/4 bg-modal-success outline-none focus:outline-none",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative p-6 flex flex-col justify-center justify-self-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: "ml-auto border-0 mb-10 text-black float-right text-xl md:text-3xl outline-none focus:outline-none",
                onClick: function onClick() {
                  return setShowModal(false);
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "text-black -mt-2 h-6 w-6 text-2xl block float-right outline-none focus:outline-none",
                  children: "x"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "".concat(conent/* strapi */.s1, "/uploads/Group_13916_2x_c5c9fcdc36.png"),
                  className: "h-36 w-36 xl:h-32 xl:w-32 rounded-lg"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mt-8 xl:mt-4 text-center text-blueGray-500 text-4xl md:text-2xl xl:text-lg",
                children: "\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "text-blueGray-500 text-center mx-8 md:mx-4 mb-6 md:mb-4  text-3xl md:text-xl xl:text-base",
                children: ["\u0E02\u0E2D\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E19\u0E43\u0E08\u0E23\u0E30\u0E1A\u0E1A", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E08\u0E30\u0E21\u0E35\u0E40\u0E08\u0E49\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E43\u0E2B\u0E49\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E40\u0E23\u0E47\u0E27"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex justify-center w-auto mb-8 md:mb-4",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/blogs",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    className: "text-white bg-contact font-bold uppercase text-4xl md:text-2xl xl:text-lg outline-none px-6 py-4 xl:py-2 rounded-lg focus:outline-none ease-linear transition-all duration-150 w-auto",
                    type: "button",
                    children: "\u0E2D\u0E48\u0E32\u0E19\u0E1A\u0E17\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21"
                  })
                })
              })]
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "opacity-25 fixed inset-0 z-40 bg-black",
        onClick: function onClick() {
          return setShowModal(false);
        }
      })]
    }) : null
  });
};

/* harmony default export */ var successRegistration = (SuccessRegistration);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./components/_OldDesign/PDPAConsent/index.ts + 2 modules
var PDPAConsent = __webpack_require__(7117);
// EXTERNAL MODULE: ./components/HoneyPot/index.ts + 1 modules
var HoneyPot = __webpack_require__(6067);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
// EXTERNAL MODULE: ./node_modules/react-cloudflare-turnstile/dist/index.js
var dist = __webpack_require__(9807);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./components/_OldDesign/forms.tsx


function forms_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function forms_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? forms_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : forms_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var ReuseForms = function ReuseForms(_ref) {
  var _form$form$filter, _form$form, _form$form2, _form$form3, _form$form4;

  var form = _ref.form,
      product = _ref.product,
      event = _ref.event,
      scroll = _ref.scroll;

  var _useState = (0,react.useState)(true),
      disable = _useState[0],
      setDisable = _useState[1];

  var _useState2 = (0,react.useState)(null),
      forms = _useState2[0],
      setForms = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      clear = _useState3[0],
      setClear = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showNoti = _useState4[0],
      setShowNoti = _useState4[1];

  var _useState5 = (0,react.useState)(),
      isSuccess = _useState5[0],
      setIsSuccess = _useState5[1];

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var _useState6 = (0,react.useState)(false),
      showSuccess = _useState6[0],
      setShowSuccess = _useState6[1];

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  var value = {};
  var contactRef = react.useRef();

  var _useState7 = (0,react.useState)(null),
      pdpaInfo = _useState7[0],
      setPdpaInfo = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      pdpaFormValid = _useState8[0],
      setPdpaFormValid = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      confirmRecaptcha = _useState9[0],
      setConfirmRecaptcha = _useState9[1];

  var _useState10 = (0,react.useState)(''),
      recaptchaToken = _useState10[0],
      setRecaptchaToken = _useState10[1];

  (0,react.useEffect)(function () {
    if (recaptchaToken) {
      setConfirmRecaptcha(true);
    } else {
      setConfirmRecaptcha(false);
    }
  }, [recaptchaToken]);
  (0,react.useEffect)(function () {
    var initPdpaInfo = (0,PDPAConsent/* initialPDPAInfoPayload */.S)(null, 'Codium form');
    setPdpaInfo(initPdpaInfo);
  }, []);
  (0,react.useEffect)(function () {
    setClear(false);
  }, [forms]);
  (0,react.useEffect)(function () {
    if (disable) {
      setDisable(false);
    } else {
      window.scrollTo({
        behavior: 'smooth',
        top: contactRef.current.offsetTop
      });
      setDisable(false);
    }
  }, [scroll]);

  var handleRecaptchaChange = function handleRecaptchaChange(token) {
    setRecaptchaToken(token);
  };

  var handleSubmitForm = function handleSubmitForm(data, e) {
    e.preventDefault();

    if (data.user_code) {
      return;
    }

    if (!recaptchaToken) {
      alert(lang === 'en' ? 'Please confirm that you are not a robot.' : 'กรุณายืนยันว่าคุณไม่ใช่หุ่นยนต์');
      return;
    }

    submitForm(data, recaptchaToken);
  };

  var submitForm = function submitForm(data, recaptchaToken) {
    var _localStorage$getItem;

    var url_ads = window.location.href;
    var from_url = (_localStorage$getItem = localStorage.getItem('fromUrl')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : url_ads;
    var dataForm = {
      product: product,
      name: data.name,
      company_name: data.company_name,
      job: data.job,
      phone: data.phoneNumber,
      email: data.email,
      from_url: from_url,
      contact_points: ['1']
    };
    axios_default().post("".concat(conent.be, "/api/codium-forms"), {
      data: forms_objectSpread(forms_objectSpread({}, dataForm), {}, {
        codiumForm: forms,
        contact_points: '["1"]',
        detail: data.detail,
        recaptcha: recaptchaToken
      }),
      pdpa_info: {
        customer_code: data.email,
        purposes: pdpaInfo.purposes
      }
    }).then(function (_ref2) {
      var res = _ref2.data;
      // Google tag manager for submit
      (0,gtm/* GTMPageView */.o)(url_ads, event);
      setShowSuccess(true);
    })["catch"](function (error) {
      setAlert(false);
      (0,esm_exports/* captureException */.Tb)(error);
    })["finally"](function () {
      setClear(!clear);
      value = {};
      setForms(null);
      var initPdpaInfo = (0,PDPAConsent/* initialPDPAInfoPayload */.S)(null, 'Codium form');
      setPdpaInfo(initPdpaInfo);
      setRecaptchaToken('');
    });
  };

  var setAlert = function setAlert(success) {
    if (success) {
      setIsSuccess(true);
    } else {
      setIsSuccess(false);
    }

    setShowNoti(true);
    setTimeout(function () {
      setShowNoti(false);
    }, 2500);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showNoti ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "top-20 right-3 fixed w-1/5 z-50 border-t-4 rounded-b px-4 py-3 shadow-md ".concat(isSuccess ? 'bg-green-100 border-green-500 text-green-900' : 'bg-red-100 border-red-500 text-red-900'),
      role: "alert",
      "data-aos": "fade-left",
      "data-aos-easing": "linear",
      "data-aos-duration": "300",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "font-bold",
          children: isSuccess ? 'Success' : 'Error'
        })
      })
    }) : '', /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      onSubmit: handleSubmit(handleSubmitForm),
      className: "pb-16 bg-gray-50 h-full py-12 xl:px-48",
      ref: contactRef,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-48 border-2 h-0 bg-red-500 border-red-500 m-auto"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-center text-3xl md:text-2xl py-12 xl:pb-2 px-32 xl:text-base",
        children: (0,translate/* translate */.Iu)(form, 'description', lang)
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 px-2 md:px-4 lg:px-16 xl:".concat(((_form$form$filter = form === null || form === void 0 ? void 0 : (_form$form = form.form) === null || _form$form === void 0 ? void 0 : _form$form.filter(function (item) {
          return item.inputType === 'checkbox';
        })) !== null && _form$form$filter !== void 0 ? _form$form$filter : []).length > 0 ? 'grid-cols-2' : '', " xl:m-auto"),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "xl:pl-40",
            children: [' ', form === null || form === void 0 ? void 0 : (_form$form2 = form.form) === null || _form$form2 === void 0 ? void 0 : _form$form2.filter(function (item) {
              return item.inputType === 'checkbox';
            }).map(function (item, i) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(input, {
                  contents: item,
                  register: register
                })
              }, i);
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: form === null || form === void 0 ? void 0 : (_form$form3 = form.form) === null || _form$form3 === void 0 ? void 0 : _form$form3.filter(function (item) {
            return item.inputType !== 'checkbox' && item.inputType !== 'button';
          }).map(function (item, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(input, {
                contents: item,
                register: register
              }), errors !== null && errors !== void 0 && errors.name && item.name == 'name' ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "-mt-3 mb-3",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "px-14 text-red text-xl xl:text-xs",
                  children: errors === null || errors === void 0 ? void 0 : errors.name.message
                })
              }) : '', errors !== null && errors !== void 0 && errors.email && item.name == 'email' ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "-mt-3 mb-3",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "px-14 text-red text-xl xl:text-xs",
                  children: errors === null || errors === void 0 ? void 0 : errors.email.message
                })
              }) : '', errors !== null && errors !== void 0 && errors.job && item.name == 'job' ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "-mt-3 mb-3",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "px-14 text-red text-xl xl:text-xs",
                  children: errors === null || errors === void 0 ? void 0 : errors.job.message
                })
              }) : '', errors !== null && errors !== void 0 && errors.company_name && item.name == 'company_name' ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "-mt-3 mb-3",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "px-14 text-red text-xl xl:text-xs",
                  children: errors === null || errors === void 0 ? void 0 : errors.company_name.message
                })
              }) : '', errors !== null && errors !== void 0 && errors.phoneNumber && item.name == 'phoneNumber' ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "-mt-3 mb-3",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "px-14 text-red text-xl xl:text-xs",
                  children: errors === null || errors === void 0 ? void 0 : errors.phoneNumber.message
                })
              }) : '']
            }, i);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(HoneyPot/* HoneyPot */.m, {
          register: register,
          onChange: function onChange() {}
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "px-2 md:px-4 lg:px-16 my-8 text-xl xl:text-xs",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "px-12",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PDPAConsent/* PDPAConsent */.d, {
            choices: ['PP-1', 'PP-2', 'PP-3'],
            payload: pdpaInfo,
            setPayload: setPdpaInfo,
            valid: pdpaFormValid,
            setValid: setPdpaFormValid
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-fit mx-auto",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((dist_default()), {
          turnstileSiteKey: conent/* turnstileSiteKey */.z,
          callback: function callback(token) {
            return handleRecaptchaChange(token);
          },
          theme: "light"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: form === null || form === void 0 ? void 0 : (_form$form4 = form.form) === null || _form$form4 === void 0 ? void 0 : _form$form4.filter(function (item) {
          return item.inputType === 'button';
        }).map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(input, {
              contents: item,
              register: register,
              disabled: !pdpaFormValid || !confirmRecaptcha
            })
          }, i);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(successRegistration, {
      showModal: showSuccess,
      setShowModal: setShowSuccess
    })]
  });
};

/* harmony default export */ var _OldDesign_forms = (ReuseForms);
// EXTERNAL MODULE: ./components/_OldDesign/OldLayout.tsx + 1 modules
var OldLayout = __webpack_require__(4990);
;// CONCATENATED MODULE: ./pages/service.tsx

















var ESignature = function ESignature(_ref) {
  var _filterContent, _findContentByTitle, _findContentByTitle2, _findContentByTitle3;

  var contents = _ref.contents;
  var router = (0,next_router.useRouter)();

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang,
      setLang = _useLocale.setLang;

  (0,react.useEffect)(function () {
    var _localStorage$getItem;

    var defaultLocale = (_localStorage$getItem = localStorage.getItem('lang')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : 'th';
    setLang(defaultLocale);
  }, []);

  var findContent = function findContent(item, name) {
    if (!item) return;
    return item.find(function (item) {
      return item.name === name || item.title === name;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-screen",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(header/* default */.Z, {
      content: {
        content: 'ซอฟต์แวร์และเทคโนโลยีที่ทันสมัย เพื่อผู้ใช้งานจริง โดยผู้เชี่ยวชาญด้านนวัตกรรมเฉพาะ',
        title: 'ซอฟต์แวร์และเทคโนโลยีที่ทันสมัย เพื่อผู้ใช้งานจริง โดยผู้เชี่ยวชาญด้านนวัตกรรมเฉพาะ',
        image: null
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(productHeader/* default */.Z, {
      headerItem: findContent(contents, 'Intro')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "px-8 xl:px-0  mt-16",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [(_filterContent = (0,translate/* filterContent */.OC)(contents, 'card')) === null || _filterContent === void 0 ? void 0 : _filterContent.sort(function (a, b) {
          return a.id - b.id;
        }).map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative ".concat((Content_module_default()).firstTitle, "  p-8 mt-32 border-2 rounded-2xl xl:m-16 lg:p-16 xl:hidden ").concat((culture_module_default()).borderBlue2),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(conent.be).concat(item === null || item === void 0 ? void 0 : item.image[0].url),
              className: "".concat((culture_module_default()).circle, "  absolute right-4 -top-28 xl:h-60"),
              alt: "CODIUM",
              loading: "lazy"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              className: "font-normal text-4xl md:text-2xl text-center mt-8",
              children: (0,translate/* translate */.Iu)(item, 'title', lang)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              className: "text-3xl md:text-xl mt-16 md:mt-8 font-light text-center",
              children: (0,translate/* translate */.Iu)(item, 'description', lang)
            }), item.subContent ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: item.subContent.map(function (sub, subId) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    "data-aos": "zoom-in",
                    "data-aos-delay": "500",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "grid grid-cols-3",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                        className: "font-normal text-4xl md:text-2xl text-left mt-8 col-span-2 xl:text-base",
                        children: (0,translate/* translate */.Iu)(sub, 'title', lang)
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "grid grid-cols-3",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: "".concat(conent.be).concat(sub === null || sub === void 0 ? void 0 : sub.image[0].url),
                        className: "m-auto xl:h-60 xl:text-xs",
                        alt: "CODIUM",
                        loading: "lazy"
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "text-3xl md:text-xl mt-16 md:mt-8 font-light text-left col-span-2",
                        children: (0,translate/* translate */.Iu)(sub, 'description', lang)
                      })]
                    })]
                  }, subId)
                });
              })
            }) : '']
          }, i);
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "hidden grid-cols-3 xl:grid xl:px-48",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-span-2",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative ".concat((Content_module_default()).firstTitle, " m-4 border-2 rounded-2xl p-4 ").concat((culture_module_default()).borderBlue2),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "".concat(conent.be).concat((_findContentByTitle = (0,translate/* findContentByTitle */.pF)(contents, 'Mobile Application')) === null || _findContentByTitle === void 0 ? void 0 : _findContentByTitle.image[0].url),
                className: "".concat((culture_module_default()).circle, "  absolute -right-4 -top-20 h-24 xl:h-16"),
                style: {
                  height: '10rem'
                },
                alt: "Mobile Application",
                loading: "lazy"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "font-normal text-2xl text-center mt-8",
                children: (0,translate/* translate */.Iu)((0,translate/* findContentByTitle */.pF)(contents, 'Mobile Application'), 'title', lang)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "text-base xl:text-xs px-2  mt-16 md:mt-8 xl:my-4 font-light text-center ".concat(lang === 'th' ? 'thai-lh' : ''),
                children: (0,translate/* translate */.Iu)((0,translate/* findContentByTitle */.pF)(contents, 'Mobile Application'), 'description', lang)
              }), (_findContentByTitle2 = (0,translate/* findContentByTitle */.pF)(contents, 'Mobile Application')) !== null && _findContentByTitle2 !== void 0 && _findContentByTitle2.subContent ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "grid grid-cols-3",
                  children: (_findContentByTitle3 = (0,translate/* findContentByTitle */.pF)(contents, 'Mobile Application')) === null || _findContentByTitle3 === void 0 ? void 0 : _findContentByTitle3.subContent.map(function (sub, subId) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      "data-aos": "zoom-in",
                      "data-aos-delay": "500",
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          src: "".concat(conent.be).concat(sub === null || sub === void 0 ? void 0 : sub.image[0].url),
                          className: "m-auto my-4 xl:h-16",
                          alt: "Mobile Application",
                          loading: "lazy"
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                          className: "font-normal text-4xl md:text-2xl text-center my-4 col-span-2 xl:text-base",
                          children: (0,translate/* translate */.Iu)(sub, 'title', lang)
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "text-base xl:text-xs mt-16 xl:mt-0 px-4 font-light text-left col-span-2 ".concat(lang === 'th' ? 'thai-lh' : ''),
                          children: (0,translate/* translate */.Iu)(sub, 'description', lang)
                        })]
                      })
                    }, subId);
                  })
                })
              }) : '']
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: contents === null || contents === void 0 ? void 0 : contents.filter(function (item) {
              return item.title.includes('Desktop Application') || item.title.includes('Web Application');
            }).map(function (item, i) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "relative ".concat((Content_module_default()).firstTitle, " m-4 mb-8 border-2 rounded-2xl p-4 hidden xl:block ").concat((culture_module_default()).borderBlue2),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "".concat(conent.be).concat(item === null || item === void 0 ? void 0 : item.image[0].url),
                  className: "".concat((culture_module_default()).circle, " absolute -right-4 -top-20 h-24"),
                  style: {
                    height: '10rem'
                  },
                  alt: "Desktop Application",
                  loading: "lazy"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                  className: "font-normal text-2xl text-center mt-8",
                  children: (0,translate/* translate */.Iu)(item, 'title', lang)
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                  className: "text-base xl:text-xs mt-16  xl:mt-4 font-light text-center ".concat(lang === 'th' ? 'thai-lh' : ''),
                  children: (0,translate/* translate */.Iu)(item, 'description', lang)
                }), item.subContent ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: item.subContent.map(function (sub, subId) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "grid col-span-2",
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "grid grid-cols-3",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                            className: "font-normal text-4xl text-left mt-8 col-span-2 xl:text-base",
                            children: (0,translate/* translate */.Iu)(sub, 'title', lang)
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          className: "grid grid-cols-3",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                            src: "".concat(conent.be).concat(sub === null || sub === void 0 ? void 0 : sub.image[0].url),
                            className: "my-auto mr-auto xl:h-32 xl:text-xs",
                            alt: "Desktop Application",
                            loading: "lazy"
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            className: "text-base xl:text-xs  mt-16  xl:mt-4 font-light text-left col-span-2",
                            children: (0,translate/* translate */.Iu)(sub, 'description', lang)
                          })]
                        })]
                      })
                    }, subId);
                  })
                }) : '']
              }, i);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "grid grid-cols-2 my-12 mt-6 xl:mt-0 xl:px-48",
          children: contents === null || contents === void 0 ? void 0 : contents.filter(function (item) {
            return item.title.includes('Artificial Intelligence') || item.title.includes('Tech Consultant');
          }).map(function (item, i) {
            var _item$image$;

            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative ".concat((Content_module_default()).firstTitle, "  m-4 border-2 rounded-2xl   p-4 hidden xl:block ").concat((culture_module_default()).borderBlue2),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "".concat(conent.be).concat((_item$image$ = item.image[0]) === null || _item$image$ === void 0 ? void 0 : _item$image$.url),
                className: "".concat((culture_module_default()).circle, " absolute -right-4 -top-20 h-24"),
                style: {
                  height: '10rem'
                },
                alt: "Artificial Intelligence",
                loading: "lazy"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "font-normal text-2xl text-center mt-8",
                children: (0,translate/* translate */.Iu)(item, 'title', lang)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "text-base xl:text-xs mt-16  xl:mt-4 font-light text-center ".concat(lang === 'th' ? 'thai-lh' : ''),
                children: (0,translate/* translate */.Iu)(item, 'description', lang)
              }), item.subContent ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: item.subContent.map(function (sub, subId) {
                  var _sub$image$;

                  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "grid col-span-2",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-3",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                          className: "font-normal text-4xl md:text-2xl text-left mt-8 col-span-2 xl:text-base",
                          children: (0,translate/* translate */.Iu)(sub, 'title', lang)
                        })]
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-3",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                          src: "".concat(conent.be).concat((_sub$image$ = sub.image[0]) === null || _sub$image$ === void 0 ? void 0 : _sub$image$.url),
                          className: "my-auto mr-auto xl:h-24 xl:text-xs",
                          loading: "lazy"
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "text-base xl:text-xs mt-16  xl:mt-4 font-light text-left col-span-2",
                          children: (0,translate/* translate */.Iu)(sub, 'description', lang)
                        })]
                      })]
                    })
                  }, subId);
                })
              }) : '']
            }, i);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(content/* default */.Z, {
        contents: contents === null || contents === void 0 ? void 0 : contents.find(function (item) {
          return item.name === 'OUR TECHNOLOGY STACK';
        }),
        padding: false
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(_OldDesign_forms, {
        form: findContent(contents, 'Forms'),
        product: 'PROJECT',
        event: 'serviceFormSubmit'
      })]
    })]
  });
};

ESignature.getLayout = function (page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OldLayout/* default */.Z, {
    children: page
  });
};

var __N_SSG = true;
/* harmony default export */ var service = (ESignature);

/***/ }),

/***/ 5834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ GTMPageView; }
/* harmony export */ });
var GTMPageView = function GTMPageView(url, event) {
  var pageEvent = {
    event: event,
    page: url
  }; //@ts-ignore

  window && window.dataLayer && window.dataLayer.push(pageEvent);
  return pageEvent;
};

/***/ }),

/***/ 9138:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service",
      function () {
        return __webpack_require__(3743);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1559:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"workHardText":"culture_workHardText__S_Z_0","primary":"culture_primary__EMOmX","royalBlueBg":"culture_royalBlueBg__O25hR","secondary":"culture_secondary__9xEvo","danger":"culture_danger__MyQSB","colorSecondary":"culture_colorSecondary__EM_w5","colorDanger":"culture_colorDanger___YVtD","eSignatureBg":"culture_eSignatureBg__gNSNW","benefit":"culture_benefit__dgiN8","careerForm":"culture_careerForm__Kf_q3","benefitImg":"culture_benefitImg__Mjkom","borderBlue":"culture_borderBlue__nL_EX","borderBlue2":"culture_borderBlue2__QwsA_","circle":"culture_circle__Y_KLm","service":"culture_service__cY1tI"};

/***/ }),

/***/ 6494:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [735,859,60,371,608,281,774,888,179], function() { return __webpack_exec__(9138); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);